export const MAX_AGE = Infinity; // Infinity means no garbage collection
export const STALE_TIME = 1000 * 45; // 45 seconds
